import { render, staticRenderFns } from "./FeatureTourCard.vue?vue&type=template&id=2929bb69&scoped=true"
import script from "./FeatureTourCard.vue?vue&type=script&lang=ts"
export * from "./FeatureTourCard.vue?vue&type=script&lang=ts"
import style0 from "./FeatureTourCard.vue?vue&type=style&index=0&id=2929bb69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2929bb69",
  null
  
)

export default component.exports